module.exports = __webpack_public_path__ + "static/media/AdUnitNavIconActive.c7ed3e06.svg";